import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import makeStyles from '@mui/styles/makeStyles';
import { NavBar, TabBar } from 'components/elements';
import { Settings } from 'components/templates';
import { useSetTabBranding } from 'hooks';

import Styles from './styles';

const useStyles = makeStyles(Styles);

function Layout({ children }) {
  const classes = useStyles();
  const { t } = useTranslation('labels');
  useSetTabBranding(t('settings'));

  return (
    <>
      <>
        <NavBar />
        <TabBar />
      </>
      <main className={classes.content}>
        <div className={classes.settingsPage}>
          <div className={classes.settingsWrapper}>
            <Settings>{children}</Settings>
          </div>
        </div>
      </main>
    </>
  );
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
